import { render, staticRenderFns } from "./StageDef.vue?vue&type=template&id=79794936&scoped=true"
import script from "./StageDef.vue?vue&type=script&lang=js"
export * from "./StageDef.vue?vue&type=script&lang=js"
import style0 from "./StageDef.vue?vue&type=style&index=0&id=79794936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79794936",
  null
  
)

export default component.exports